import React, { useRef, useState } from "react";
import "./color-swatches.scss";

const COLORS = [
  "#3b3b3b", "#89afb4", "#d4745e", "#eecd81", "#bf94b2", "#826860", "#b887ac",
  "#d1624f", "#d6d85a", "#39a7a4", "#6c77a7", "#f8df51", "#e4a380", "#dc8e8d",
  "#6daed1", "#727272", "#daa4bb", "#ebc194", "#efe47f", "#a4d1e4", "#8dc2b0",
  "#aec977", "#7398c0", "#b2b2b2", "#aca1be", "#c76573",
];
export default function ColorSwatches({
  returnColor, defColor, columns = 6, size = 30, round = false,
  preserveSelection = false, stretch = false, customOnChange = false, onClear, className = "",
}) {
  const [custom, setCustom] = useState(/^#[0-9a-f]{6}$/i.test(defColor || "") ? defColor : COLORS[0]);
  const range = useRef(null);
  const choose = (color) => {
    setCustom(color);
    if (preserveSelection && range.current?.commonAncestorContainer.isConnected) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range.current);
    }
    returnColor(color);
  };
  return <div className={`ant-colors${stretch ? " ant-colors--stretch" : ""} ${className}`} style={{ "--color-columns": columns, "--color-size": `${size}px`, "--color-radius": round ? "50%" : "5px" }}>
    <div className="ant-colors__grid">
      {COLORS.map(color => <button key={color} type="button" aria-label={`Color ${color}`}
        aria-pressed={color.toLowerCase() === defColor?.toLowerCase()} title={color}
        style={{ background: color }} onMouseDown={event => {
          if (preserveSelection && event.button === 0) { event.preventDefault(); choose(color); }
        }} onClick={event => { if (!preserveSelection || event.detail === 0) choose(color); }}>
        {color.toLowerCase() === defColor?.toLowerCase() ? "✓" : ""}
      </button>)}
    </div>
    <div className="ant-colors__custom">
      <label>Custom <input type="color" value={custom} aria-label="Custom color"
        onPointerDown={() => {
          const selection = window.getSelection();
          range.current = preserveSelection && selection?.rangeCount ? selection.getRangeAt(0).cloneRange() : null;
        }} onChange={event => { setCustom(event.target.value); if (customOnChange) choose(event.target.value); }} /></label>
      {!customOnChange && <button type="button" onMouseDown={event => { if (preserveSelection) event.preventDefault(); }} onClick={() => choose(custom)}>Use color</button>}
      {onClear && <button type="button" onMouseDown={event => { if (preserveSelection) event.preventDefault(); }} onClick={onClear}>Clear</button>}
    </div>
  </div>;
}
